var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C5 10.4477 5.44772 10 6 10H6.01C6.56228 10 7.01 10.4477 7.01 11C7.01 11.5523 6.56228 12 6.01 12H6C5.44772 12 5 11.5523 5 11Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C9.44771 10 9 10.4477 9 11C9 11.5523 9.44771 12 10 12H12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10H10Z",
    fill: "#011235"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.4445C5 14.8922 5.44772 14.4445 6 14.4445H6.01C6.56228 14.4445 7.01 14.8922 7.01 15.4445C7.01 15.9967 6.56228 16.4445 6.01 16.4445H6C5.44772 16.4445 5 15.9967 5 15.4445Z",
    fill: "#011235"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.4445C9.44771 14.4445 9 14.8922 9 15.4445C9 15.9967 9.44771 16.4445 10 16.4445H12C12.5523 16.4445 13 15.9967 13 15.4445C13 14.8922 12.5523 14.4445 12 14.4445H10Z",
    fill: "#011235"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22634 2H3.28571C2.41933 2 1.58531 2.33865 0.967953 2.94636C0.350061 3.55459 0 4.38292 0 5.25V18.75C0 19.6171 0.350061 20.4454 0.967953 21.0536C1.58531 21.6614 2.41933 22 3.28571 22H14.7143C15.5807 22 16.4147 21.6614 17.032 21.0536C17.6499 20.4454 18 19.6171 18 18.75V5.25C18 4.38292 17.6499 3.55459 17.032 2.94636C16.4147 2.33865 15.5807 2 14.7143 2H12.7737C12.3384 0.863176 11.3108 0 10 0H8C6.68917 0 5.66155 0.863176 5.22634 2ZM7 3.22222C7 2.4455 7.54421 2 8 2H10C10.4558 2 11 2.4455 11 3.22222C11 3.99895 10.4558 4.44444 10 4.44444H8C7.54421 4.44444 7 3.99895 7 3.22222ZM12.91 4C12.5945 5.34849 11.477 6.44444 10 6.44444H8C6.52296 6.44444 5.4055 5.34849 5.08998 4H3.28571C2.93968 4 2.61094 4.13546 2.37099 4.37166C2.13157 4.60734 2 4.92361 2 5.25V18.75C2 19.0764 2.13157 19.3927 2.37099 19.6283C2.61094 19.8645 2.93968 20 3.28571 20H14.7143C15.0603 20 15.3891 19.8645 15.629 19.6283C15.8684 19.3927 16 19.0764 16 18.75V5.25C16 4.92361 15.8684 4.60734 15.629 4.37166C15.3891 4.13546 15.0603 4 14.7143 4H12.91Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInfo);
export default __webpack_public_path__ + "static/media/general-info.c6a4eb9343e7c7d089ad261481c94632.svg";
export { ForwardRef as ReactComponent };